__turbopack_context__.v({
  "appDownload": "drawer-module-scss-module__hGkXsG__appDownload",
  "appDownloadAndLogo": "drawer-module-scss-module__hGkXsG__appDownloadAndLogo",
  "appDownloadAndLogoHide": "drawer-module-scss-module__hGkXsG__appDownloadAndLogoHide",
  "chevronIcon": "drawer-module-scss-module__hGkXsG__chevronIcon",
  "chevronIconWrapper": "drawer-module-scss-module__hGkXsG__chevronIconWrapper",
  "closeButton": "drawer-module-scss-module__hGkXsG__closeButton",
  "closeButtonWrapper": "drawer-module-scss-module__hGkXsG__closeButtonWrapper",
  "closeIconButton": "drawer-module-scss-module__hGkXsG__closeIconButton",
  "darktheme": "drawer-module-scss-module__hGkXsG__darktheme",
  "drawer": "drawer-module-scss-module__hGkXsG__drawer",
  "innerDrawer": "drawer-module-scss-module__hGkXsG__innerDrawer",
  "innerDrawerHeader": "drawer-module-scss-module__hGkXsG__innerDrawerHeader",
  "mobileButtonWrapper": "drawer-module-scss-module__hGkXsG__mobileButtonWrapper",
  "mobileNavDropdownWrapper": "drawer-module-scss-module__hGkXsG__mobileNavDropdownWrapper",
  "mobileSupportButton": "drawer-module-scss-module__hGkXsG__mobileSupportButton",
  "mobileTileContainer": "drawer-module-scss-module__hGkXsG__mobileTileContainer",
  "navButton": "drawer-module-scss-module__hGkXsG__navButton",
  "navItem": "drawer-module-scss-module__hGkXsG__navItem",
  "navLink": "drawer-module-scss-module__hGkXsG__navLink",
  "navList": "drawer-module-scss-module__hGkXsG__navList",
  "open": "drawer-module-scss-module__hGkXsG__open",
  "sxmLogoWaterMark": "drawer-module-scss-module__hGkXsG__sxmLogoWaterMark",
});
